import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { changeSearchFilterEpic } from './_epics/changeSearchFilter.epic';
import { initSearchFilterEpic } from './_epics/initSearchFilter.epic';

export const searchFilterEpic = safeCombineEpics(
  changeSearchFilterEpic,
  initSearchFilterEpic,
);
